import * as units from '../utils/units.js'

export default class Geometry {
  topEdge = 5
  bottomEdge = 5
  leftEdge = 5
  rightEdge = 5
  nRows = 2
  nColumns = 2
  rowSpacing = 2
  columnSpacing = 2
  dirty = false

  deserialize(json) {
    Object.assign(this, json)
    this.dirty = false
  }

  serialize() {
    const d = {}
    Object.keys(this).forEach( (key) => d[key] = this[key] )
    return d
  }

  onEdgesUpdate(detail) {
    this.leftEdge = units.parseLength(detail.leftEdge)
    this.rightEdge = units.parseLength(detail.rightEdge)
    this.topEdge = units.parseLength(detail.topEdge)
    this.bottomEdge = units.parseLength(detail.bottomEdge)
    this.publishUpdate()
  }

  onRowColumnUpdate(detail) {
    this.nColumns = detail.nColumns
    this.nRows = detail.nRows
    this.columnSpacing = units.parseLength(detail.columnSpacing)
    this.rowSpacing = units.parseLength(detail.rowSpacing)
    this.publishUpdate()
  }

  publishUpdate() {
    this.dirty = true
    let event = new CustomEvent('anchor-model-update', { detail: this });
    document.dispatchEvent(event)
    // update our button
    event = new CustomEvent('geometry-model-update', { detail: {geometry: this} });
    document.dispatchEvent(event)
  }
}